// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  AggregateSpec,
  WindowSize,
} from "./types";

export default {
  projectId: __t.u32(),
  name: __t.string(),
  description: __t.string(),
  inputStreamName: __t.string(),
  get aggregate() {
    return AggregateSpec;
  },
  get window() {
    return WindowSize;
  },
  anchorOffsetMinutes: __t.i32(),
  outputStreamName: __t.string(),
  enabled: __t.bool(),
};
